import React from 'react'
import './contact.css'
import {MdOutlineEmail} from 'react-icons/md'
import {BsLinkedin} from 'react-icons/bs'
import {BsWhatsapp} from 'react-icons/bs'
import { useRef } from 'react';
import emailjs from 'emailjs-com'

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_jzw7p5j', 'template_25gssb5', form.current, 'nARKmB8rD_dstB7ZK')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });

    e.target.reset()
  };


  return (
    <section id='contact'>
      <h5>Get in touch</h5>
      <h2>Contact Me</h2>
      <div className="container">
        <div className="contact__container">
          <div className="contact__options">
            <article className="contact__option">
              <MdOutlineEmail className='contact__option-icon'/>
              <h4>Email</h4>
              <h5>rejoiceoedokpayi@gmail.com</h5>
              <a href="mailto:rejoiceoedokpayi@gmail.com" target='_blank'>Send a message</a>
            </article>

            <article className="contact__option">
              <BsLinkedin className='contact__option-icon'/>
              <h4>LinkedIn</h4>
              <h5>Rejoice Edokpayi</h5>
              <a href="https://www.linkedin.com/in/rejoicedokpayi/" target='_blank'>Send a message</a>
            </article>

            <article className="contact__option">
              <BsWhatsapp className='contact__option-icon'/>
              <h4>Whatsapp</h4>
              <h5>rejoiceoedokpayi@gmail.com</h5>
              <a href="https://api.whatsapp.com/send?phone=2349099184922" target='_blank'>Send a message</a>
            </article>
          </div>
          {/* END OF CONTACT OPTIONS */}

          <form ref={form} onSubmit={sendEmail}>
            <input type="text" name='name' placeholder='Your Full Name' required />
            <input type="email" name='email' placeholder='Your Email' required />
            <textarea name="message" rows="10" placeholder='Your message' required></textarea>

            <button type='submit' className="btn btn-primary">Send Message</button>
          </form>


        </div>
      </div>
    </section>
  )
}

export default Contact